import { evidenceFileMetadata } from '@hjci-investorhub-v2/shared';
import { api } from '../../lib/api';

export async function uploadEvidence(entityId: string, file: File, signal: AbortSignal): Promise<string> {
  const metadata = evidenceFileMetadata(file);
  if (!metadata.success) throw new Error(metadata.error.issues[0].message);
  const { id, url, headers } = await api<{ id: string; url: string; headers?: Record<string, string> }>('/evidence/upload-url', {
    method: 'POST', body: JSON.stringify({ entityType: 'corporate-action', entityId, ...metadata.data }), signal,
  });
  const response = await fetch(url, { method: 'PUT', body: file, headers: headers ?? { 'Content-Type': metadata.data.contentType }, signal });
  if (!response.ok) throw new Error(`File upload failed (${response.status}). Retry to attach this file.`);
  await api(`/evidence/${id}/confirm`, { method: 'POST', body: '{}', signal });
  return id;
}
